/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SearchPlayerRequestContent
 */
export interface SearchPlayerRequestContent {
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerRequestContent
     */
    searchTerm?: string;
}


/**
 * Check if a given object implements the SearchPlayerRequestContent interface.
 */
export function instanceOfSearchPlayerRequestContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayerRequestContentFromJSON(json: any): SearchPlayerRequestContent {
    return SearchPlayerRequestContentFromJSONTyped(json, false);
}

export function SearchPlayerRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayerRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'searchTerm': !exists(json, 'searchTerm') ? undefined : json['searchTerm'],
    };
}

export function SearchPlayerRequestContentToJSON(value?: SearchPlayerRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'searchTerm': value.searchTerm,
    };
}

